module.exports = __webpack_public_path__ + "img/q2_sp.19c7fce5.svg";